export const Eye = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.0013 3.33398C4.66797 3.33398 1.8213 5.40732 0.667969 8.33398C1.8213 11.2607 4.66797 13.334 8.0013 13.334C11.3346 13.334 14.1813 11.2607 15.3346 8.33398C14.1813 5.40732 11.3346 3.33398 8.0013 3.33398ZM8.0013 11.6673C6.1613 11.6673 4.66797 10.174 4.66797 8.33398C4.66797 6.49398 6.1613 5.00065 8.0013 5.00065C9.8413 5.00065 11.3346 6.49398 11.3346 8.33398C11.3346 10.174 9.8413 11.6673 8.0013 11.6673ZM8.0013 6.33398C6.89464 6.33398 6.0013 7.22732 6.0013 8.33398C6.0013 9.44065 6.89464 10.334 8.0013 10.334C9.10797 10.334 10.0013 9.44065 10.0013 8.33398C10.0013 7.22732 9.10797 6.33398 8.0013 6.33398Z"
      fill="#2469F3"
    />
  </svg>
);
